import React from 'react';
import './SuccessDialog.css';

const SuccessDialog = ({ isOpen, onClose, onViewInFolder, message, showViewInFolder = true }) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-container success-dialog glass-card" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h3 className="dialog-title">
            PixlSizer
            <div className="success-icon">✅</div>
          </h3>
        </div>
        
        <div className="dialog-content">
          <p className="dialog-message success-message">
            {message}
          </p>
        </div>
        
        <div className="dialog-actions">
          {showViewInFolder && (
            <button 
              className="glass-button glass-button-secondary" 
              onClick={onViewInFolder}
            >
              <span className="button-icon">📁</span>
              View in Folder
            </button>
          )}
          <button 
            className="glass-button" 
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessDialog;